import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'booleanYesNoPipe',
  pure: true,
  standalone: false,
})
export class BooleanYesNoPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}

  /**
   * @param notSpecifiedKey optional translation key shown for `null`/`undefined`.
   * Without it, missing values are shown as "Nein" (legacy behaviour).
   */
  transform(value: boolean, notSpecifiedKey?: string): any {
    if (notSpecifiedKey && (value === null || value === undefined)) {
      return this._translate.instant(notSpecifiedKey);
    }
    let text = this._translate.instant('NO');
    if (value) {
      text = this._translate.instant('YES');
    }
    return text;
  }
}
